import { asyncRoutes, constantRoutes } from '@/router'

/**
 * 根据 meta.role 鉴权
 */
// function hasPermission(roles, route) {
//   if (route.meta && route.meta.roles) {
//     return roles.some(role => route.meta.roles.includes(role))
//   } else {
//     return true
//   }
// }

/**
 * 根据 meta.types 鉴权
 */
function hasPermission1(roles, route) {
  if (route.meta && route.meta.types) {
    return roles.some(role => route.meta.types.includes(role))
  } else {
    return true
  }
}

/**
 * 递归过滤路由表
 */
export function filterAsyncRoutes(routes, roles) {
  const res = []
  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission1(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles)
      }
      res.push(tmp)
    }
  })
  return res
}

const state = {
  routes: [], // 侧边栏渲染路由
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes = []) => {
    console.log('%c Line:50 🎂 routes', 'color:#fca650', routes)
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  }
}

const actions = {
  generateRoutes({ commit, rootState }, rolesInfo) {
    return new Promise(resolve => {
      const accessedRoutes = filterAsyncRoutes(asyncRoutes, [1, 2, 4]) // 个人
      // if (rootState.user.userInfo.username === 'icas_admin' || rootState.user.userInfo.username === 'cas_admin' || rootState.user.userInfo.username === 'icas_wenjun' || rootState.user.userInfo.username === 'icas_zengqiang' || rootState.user.userInfo.username === 'icas_wucou') {
      //   accessedRoutes = filterAsyncRoutes(asyncRoutes, [1, 2, 3, 4]) // 企业-分流界面
      // } else {
      //   if (rootState.user.userInfo.userType === 1) { // 个人登录
      //     accessedRoutes = filterAsyncRoutes(asyncRoutes, [1, 2, 4]) // 个人
      //   } else if (rootState.user.userInfo.userType === 2) { // 企业登录
      //     accessedRoutes = filterAsyncRoutes(asyncRoutes, [2]) // 企业-分流界面
      //   } else {
      //     accessedRoutes = [{ path: '*', redirect: '/404', hidden: true }]
      //   }
      // }
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
